import React from 'react'
import {Link} from 'react-router-dom'
const ResetSent = () => {
  return (
    <div className="min-h-full lg:bg-light-blue white-space-normal overflow-y-hidden">
    <div className=" bg-white lg:bg-light-blue  h-screen w-full grid place-items-center overflow-y-hidden pb-0  ">
    <div className="bg-white lg:shadow-lg rounded-lg w-full h-auto lg:w-96 p-6">
 {/* header */}
 <div className="flex flex-col justify-center items-center h-24 w-full ">
     <h1 className="font-poppins font-semi-bold text-2xl" >
     Email Sent
     </h1>
     <div className="underline" />
 </div>

        {/* Mail Sent */}
        <div className="flex flex-col   w-full mt-2  ">
          <p className="font-poppins font-medium text-gray text-tiny mb-2" >
          Please check your email and reset your password
          </p>
          </div>
   
         <div className="flex flex-col bg-gray  w-full h-0.5 " />
     {/* FORGOT PASSWORD */}
     <div className="flex  w-full mt-2  justify-between items-center ">
    <Link to="/login" className="font-poppins font-medium text-gray text-tiny mb-2" >
    Login
    </Link>
    <Link to="/register" className="font-poppins font-medium text-gray text-tiny mb-2" >
      Create account
    </Link>
    </div>
    </div>
     </div>
     </div>
  )
}

export default ResetSent